export default __webpack_public_path__ + "static/media/heroPlunge.bb6e35b9.png";